import { IoWarningSharp } from 'react-icons/io5';
import { BsFillExclamationCircleFill } from 'react-icons/bs';

export const IconWarningTriangle = IoWarningSharp;
export const IconWarningCircle = BsFillExclamationCircleFill;
